<ng-container #content>
  <div class="unauthorized-modal">
    <div class="unauthorized-modal-wrapper">
      @if (closable) {
      <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
      </button>
      }
      <div class="unauthorized-modal-puddle">
        <img src="assets/unauthorized-modal/application.svg" />
      </div>
      <div class="unauthorized-modal-content">
        @if (!previousUrlIsExternal) {
        <a class="back-link" (click)="goBack()" i18n="@@uiModals-unauthorized-backLinkText">
          <mat-icon class="icon-arrow-left">arrow_left_alt</mat-icon>
          Zurück
        </a>
        }
        <bau365-shell-logo-dark class="unauthorized-modal-logo"></bau365-shell-logo-dark>
        <h4 i18n="@@uiModals-unauthorized-headline" class="unauthorized-modal-header mat-headline-4"
          >Registrieren Sie sich jetzt kostenlos und profitieren von</h4
        >
        <ul>
          <li i18n="@@uiModals-unauthorized-list-item-1">individualisierten News</li>
          <li i18n="@@uiModals-unauthorized-list-item-2">allen Inhalten im Detail</li>
          <li i18n="@@uiModals-unauthorized-list-item-3">sofortiger Nutzung neuer Features</li>
          <li i18n="@@uiModals-unauthorized-list-item-4">uvm.</li>
        </ul>
      </div>
    </div>
    <div class="unauthorized-modal-actions">
      <p i18n="@@uiModals-unauthorized-moreInfo" class="unauthorized-modal-actions__hint">
        Weitere Informationen finden Sie auf unserer
        <a class="link" routerLink="/" mat-dialog-close>Startseite</a>.
      </p>
      <div class="unauthorized-modal-actions__registration">
        <a
          [href]="registrationLink"
          mat-flat-button
          color="primary"
          class="unauthorized-modal-actions__registration-button"
          i18n="@@uiModals-unauthorized-registerLinkLabel">
          Jetzt Registrieren
        </a>
      </div>
    </div>
    <div class="unauthorized-modal-footer" i18n="@@uiModals-unauthorized-footer-alreadyRegistered">
      Sie haben bereits einen Account?
      <a class="link" [href]="loginLink">Hier anmelden!</a>
    </div>
  </div>
</ng-container>
